import { useTranslation } from 'react-i18next';
import { SubscriptionBlockSubStatuses } from '@subscriptions/domain/types/SubscriptionsConst';
import { PaymentStatusBadge } from '@subscriptions/presentation/components/base/PaymentStatusBadge/PaymentStatusBadge';

interface LicenseStatusBadgeProps {
  variant: 'paid' | 'pending';
}

/**
 * LicenseStatusBadge - License payment status badge ("Pagada" / "Por pagar").
 *
 * Reuses {@link PaymentStatusBadge} for appearance/icon and injects the
 * subscriptions-namespace label so the license copy ("Por pagar") stays
 * independent from the payment-history status copy ("Pendiente").
 *
 * @param {Object} props - Component properties
 * @param {'paid' | 'pending'} props.variant - License badge variant
 * @returns {React.ReactElement} Localized license status badge
 */
export const LicenseStatusBadge = ({ variant }: LicenseStatusBadgeProps) => {
  const { t } = useTranslation('subscriptions');

  const status = variant === 'paid' ? SubscriptionBlockSubStatuses.PAID : SubscriptionBlockSubStatuses.PENDING;

  return <PaymentStatusBadge label={t(`licenseStatus.${variant}`)} showIcon status={status} />;
};
